import { render, staticRenderFns } from "./RegistrationPayment.vue?vue&type=template&id=4de08040&scoped=true"
import script from "./RegistrationPayment.vue?vue&type=script&lang=js"
export * from "./RegistrationPayment.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPayment.vue?vue&type=style&index=0&id=4de08040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de08040",
  null
  
)

export default component.exports